import { AugmentedExploreUser } from "../../../homeContext.ts";

export const hasUnlimitedCopies = (credit: VST.Bridge.AssetCredit): boolean => {
  if (credit === undefined || credit === null) {
    return false;
  }
  return (
    credit.copies === undefined ||
    credit.copies === null ||
    credit.copies.total === -1
  );
};

export const isUnlimitedUserCredit = (
  credit: VST.Bridge.UserCredit
): boolean => {
  if (credit === undefined || credit === null) {
    return false;
  }
  return (
    credit.credits === undefined ||
    credit.credits === null ||
    credit.credits.total === -1
  );
};

type CreditMap = Record<string, VST.Bridge.AssetCredit | VST.Bridge.UserCredit>;
type CreditList = VST.Bridge.AssetCredit[] | VST.Bridge.UserCredit[];

export const mapCreditsByIds = (credits: CreditList): CreditMap => {
  const emptyCreditMap: CreditMap = {};
  const list: (typeof credits)[number][] = credits;
  return list.reduce(
    (
      acc: typeof emptyCreditMap,
      c: VST.Bridge.AssetCredit | VST.Bridge.UserCredit
    ) => {
      acc[c.id] = c;
      return acc;
    },
    emptyCreditMap
  );
};

export const getBestCreditForAsset = (
  user: AugmentedExploreUser,
  asset: VST.Bridge.Asset
) => {
  const userCredits = user.creditList;
  const assetCredits =
    asset.creditList?.filter(
      (credit) => hasUnlimitedCopies(credit) || credit?.copies!.available > 0
    ) ?? [];

  const availableCredits = userCredits.filter(
    (userCredit) =>
      !!assetCredits.find((assetCredit) => assetCredit.id === userCredit.id)
  );

  const bestCredit = availableCredits.find((credit) =>
    isUnlimitedUserCredit(credit)
  );

  return bestCredit ?? userCredits[0] ?? null;
};
